import { AxiosError } from 'axios';
import { openErrorNotification } from 'hyarchis-global';
import {
  DocumentGroup,
  DocumentGroupAbstract,
  DocumentGroupRequest,
  DocumentGroupResponse,
} from 'types/documentGroup';
import { HcsAPI } from '..';
import formatAxiosError from '../api-error-handler/ApiErrorHandler';
import mapDocumentGroup from './mapper';

class DocumentGroupRepository {
  async get(documentGroupId: string): Promise<DocumentGroup> {
    try {
      const { data } = await HcsAPI.get<DocumentGroupAbstract>(`documentGroups/${documentGroupId}`);
      return mapDocumentGroup(data);
    } catch (error) {
      throw formatAxiosError(
        error as AxiosError,
        'An error has occured while retrieving documents group.',
      );
    }
  }

  async createDocumentForDocumentGroup(
    file: File,
    documentGroupId: string,
  ): Promise<DocumentGroupResponse> {
    const formData = new FormData();
    formData.append('request', JSON.stringify({}));
    formData.append('File', file);
    try {
      const { data } = await HcsAPI.post<DocumentGroupResponse>(
        `documentGroups/${documentGroupId}/documents`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      return data;
    } catch (error) {
      throw formatAxiosError(
        error as AxiosError,
        'An error has occured while creating processing job.',
      );
    }
  }

  async removeDocumentFromGroup(documentGroupId: string, documentId: string) {
    try {
      await HcsAPI.delete(`documentGroups/${documentGroupId}/documents/${documentId}`);
    } catch (error) {
      const axiosError = error as AxiosError;
      if (axiosError.response && axiosError.response.status === 404) {
        return;
      }
      throw formatAxiosError(axiosError, 'An error has occured while deleting document.');
    }
  }

  async create(groupName: string, workflowId: string): Promise<DocumentGroup> {
    try {
      const request: DocumentGroupRequest = {
        workflowId: workflowId.length > 0 ? workflowId : undefined,
        groupName,
      };

      const { data } = await HcsAPI.post<DocumentGroupAbstract>('documentGroups', request);
      return mapDocumentGroup(data);
    } catch (error) {
      const axiosError = error as AxiosError;
      openErrorNotification(axiosError.response?.data?.error?.message);
      throw formatAxiosError(axiosError, 'An error has occured while creating document.');
    }
  }
}

export default new DocumentGroupRepository();
